import React from 'react';
import { Table, UncontrolledTooltip, Alert } from 'reactstrap';
import moment from 'moment/min/moment-with-locales';
import UserButtons from '../shared/userButtons';
import { useTranslation } from 'react-i18next';
import * as utils from '../../Services/utils';
import { basicDateFormat } from '../../Helpers/dateTimeHelper';
import { hasAdminRole } from '../../Services/utils';
import BooleanButtons from '../shared/booleanButtons';
import { confirmEmailManually } from '../../Services/adminService';
import useAuthStore from '../../../../stores/authStore';

const UsersTable = ({ users, hasEditingRole, onStatusRefresh, onItemClicked }) => {
  const { t } = useTranslation();
  const globalUser = useAuthStore((state) => state.user);

  return (
    <div>
      {users && users.length > 0 ? (
        <div style={{ overflowX: 'auto', width: '100%' }}>
          <Table striped bordered style={{ minWidth: '800px' }}>
            <thead>
              <tr>
                <th></th>
                <th hidden>ID</th>
                <th>{t('common.FIRST_NAME')}</th>
                <th>{t('common.LAST_NAME')}</th>
                <th>{t('common.USERNAME')}</th>
                <th>{t('common.STATUS')}</th>
                <th>{t('common.E_MAIL')}</th>
                <th>{t('common.E_MAIL_CONFIRMED')}</th>
                <th>{t('settings.USER_ROLES')}</th>
                <th>{t('common.CREATED')}</th>
                <th>{t('common.LAST_ACTIVE')}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {users.map((user, index) => (
                <tr key={index}>
                  <td hidden>{user.id}</td>
                  <td>{index + 1}</td>
                  <td>{user.firstName}</td>
                  <td>{user.lastName}</td>
                  <td>{user.username}</td>
                  <td>
                    <UserButtons user={user} hasEditingRole={hasEditingRole} onStatusRefresh={onStatusRefresh} />
                  </td>
                  <td>{user.email}</td>
                  {hasAdminRole(globalUser) ? (
                    <td>
                      <BooleanButtons
                        currentStatus={user.emailConfirmed && user.emailConfirmed.toLowerCase()}
                        onStatusRefresh={onStatusRefresh}
                        functionToUpdateBe={confirmEmailManually}
                        id={user.id}
                      />
                    </td>
                  ) : (
                    <td
                      style={
                        user.emailConfirmed && user.emailConfirmed.toLowerCase() === 'false'
                          ? { color: 'red' }
                          : { color: 'GrayText' }
                      }
                    >
                      {utils.translateBooleanValue(user.emailConfirmed)}
                    </td>
                  )}
                  <td>{user.roles && user.roles[0]}</td>
                  <td>{moment.utc(user.created).format(basicDateFormat)}</td>
                  <td>{moment.utc(user.lastActive).fromNow()}</td>
                  <td className="text-center">
                    <em
                      id={`eyeButton-${index}`}
                      style={{ cursor: 'pointer' }}
                      className="fa-2x mr-2 fas icon-eye icon-hover-effect-no-color"
                      onClick={() => onItemClicked('view', user)}
                    >
                      <UncontrolledTooltip
                        delay={{ show: 300, hide: 0 }}
                        placement="left"
                        target={`eyeButton-${index}`}
                      >
                        {t('common.DETAILS')}
                      </UncontrolledTooltip>
                    </em>
                    {hasEditingRole && (
                      <em
                        id={`pencilButton-${index}`}
                        style={{ cursor: 'pointer' }}
                        className="fa-2x mr-2 fas icon-pencil icon-hover-effect-no-color"
                        onClick={() => onItemClicked('edit', user)}
                      >
                        <UncontrolledTooltip
                          delay={{ show: 300, hide: 0 }}
                          placement="left"
                          target={`pencilButton-${index}`}
                        >
                          {t('common.EDIT')}
                        </UncontrolledTooltip>
                      </em>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      ) : (
        <Alert color="success">
          <em id="noJobsYetInfo" className="fa-x mr-2 icon-info">
            <b>{t('settings.NO_USERS_YET_MSG')}</b>
          </em>
        </Alert>
      )}
    </div>
  );
};

export default UsersTable;
